var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_450",
    "data-name": "Rectangle 450",
    width: 56.53,
    height: 57.969,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1944",
    "data-name": "Groupe 1944",
    transform: "translate(-474 -8631)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 53,
    cy: 53,
    r: 53,
    transform: "translate(474 8631)",
    fill: "#d4b993"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1938",
    "data-name": "Groupe 1938",
    transform: "translate(9.64 9.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1936",
    "data-name": "Groupe 1936",
    transform: "translate(489.301 8643.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1935",
    "data-name": "Groupe 1935",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_735",
    "data-name": "Trac\\xE9 735",
    d: "M162.044,366.6h-7.217a2.714,2.714,0,0,1-2.711-2.711v-.041a2.714,2.714,0,0,1,2.711-2.711h7.217a2.714,2.714,0,0,1,2.711,2.711v.041a2.714,2.714,0,0,1-2.711,2.711m-7.217-3.573a.822.822,0,0,0-.821.821v.041a.822.822,0,0,0,.821.821h7.217a.822.822,0,0,0,.821-.821v-.041a.822.822,0,0,0-.821-.821Z",
    transform: "translate(-130 -308.631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_736",
    "data-name": "Trac\\xE9 736",
    d: "M155.255,342.027h-10a2.714,2.714,0,0,1-2.711-2.711v-.041a2.714,2.714,0,0,1,2.711-2.711h10a2.714,2.714,0,0,1,2.711,2.711v.041a2.714,2.714,0,0,1-2.711,2.711m-10-3.573a.822.822,0,0,0-.821.821v.041a.822.822,0,0,0,.821.821h10a.822.822,0,0,0,.821-.821v-.041a.821.821,0,0,0-.821-.821Z",
    transform: "translate(-121.819 -287.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_737",
    "data-name": "Trac\\xE9 737",
    d: "M150.084,317.454H137.963a2.714,2.714,0,0,1-2.711-2.711v-1.807a.945.945,0,0,1,.945-.945h15.652a.945.945,0,0,1,.945.945v1.807a2.714,2.714,0,0,1-2.711,2.711m-12.941-3.573v.862a.822.822,0,0,0,.821.821h12.121a.822.822,0,0,0,.821-.821v-.862Z",
    transform: "translate(-115.588 -266.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_738",
    "data-name": "Trac\\xE9 738",
    d: "M163.738,135.837l-.464-.566c-.159-.194-3.877-4.807-3.04-10.58.552-3.806,2.939-7.165,7.1-9.985l.938-.637.457,1.038c1.9,4.322,3.521,10.584.409,15.871a11.871,11.871,0,0,1-4.732,4.551Zm3.708-18.891c-3.116,2.354-4.911,5.046-5.342,8.016a12.678,12.678,0,0,0,2.168,8.462,10.505,10.505,0,0,0,3.282-3.488c1.984-3.444,1.947-7.81-.108-12.99",
    transform: "translate(-136.832 -97.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_739",
    "data-name": "Trac\\xE9 739",
    d: "M182.489,192.806a.945.945,0,0,1-.92-.731c-.13-.56-3.139-13.8,1.472-21.307a.945.945,0,1,1,1.61.99c-4.209,6.849-1.272,19.759-1.242,19.889a.946.946,0,0,1-.921,1.159",
    transform: "translate(-154.245 -145.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_740",
    "data-name": "Trac\\xE9 740",
    d: "M112.566,113.582a.945.945,0,0,1-.945-.945,25.393,25.393,0,0,1,3.507-12.144c1.536-2.324,2.986-4.518,2.986-7.6a13.473,13.473,0,1,0-26.945,0c0,3.325,1.55,5.607,3.19,8.022a24.027,24.027,0,0,1,3.5,11.721.945.945,0,1,1-1.89,0A22.2,22.2,0,0,0,92.8,101.982c-1.652-2.431-3.52-5.181-3.52-9.088a15.363,15.363,0,1,1,30.725,0c0,3.65-1.752,6.3-3.3,8.639a23.594,23.594,0,0,0-3.195,11.1.945.945,0,0,1-.945.945",
    transform: "translate(-76.299 -66.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_741",
    "data-name": "Trac\\xE9 741",
    d: "M189.388,7.583a.945.945,0,0,1-.945-.945V.945a.945.945,0,0,1,1.89,0V6.638a.945.945,0,0,1-.945.945",
    transform: "translate(-161.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_742",
    "data-name": "Trac\\xE9 742",
    d: "M126.076,18.558a.945.945,0,0,1-.888-.622l-1.947-5.35a.945.945,0,1,1,1.776-.647l1.947,5.35a.946.946,0,0,1-.888,1.269",
    transform: "translate(-105.273 -9.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_743",
    "data-name": "Trac\\xE9 743",
    d: "M70.337,50.524a.943.943,0,0,1-.724-.338l-3.66-4.361A.945.945,0,0,1,67.4,44.61l3.66,4.361a.945.945,0,0,1-.723,1.552",
    transform: "translate(-56.174 -37.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_744",
    "data-name": "Trac\\xE9 744",
    d: "M28.889,99.626a.938.938,0,0,1-.472-.127l-4.931-2.847a.945.945,0,1,1,.945-1.637l4.931,2.847a.945.945,0,0,1-.473,1.764",
    transform: "translate(-19.668 -81.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_745",
    "data-name": "Trac\\xE9 745",
    d: "M6.739,159.944a.941.941,0,0,1-.165-.015l-5.607-.988a.945.945,0,0,1,.328-1.861l5.607.989a.945.945,0,0,1-.163,1.876",
    transform: "translate(-0.159 -134.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_746",
    "data-name": "Trac\\xE9 746",
    d: "M.943,219.377A.945.945,0,0,1,.78,217.5l5.607-.989a.945.945,0,1,1,.328,1.861l-5.607.989a.942.942,0,0,1-.165.015",
    transform: "translate(0.001 -185.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_747",
    "data-name": "Trac\\xE9 747",
    d: "M23.424,270.758a.945.945,0,0,1-.473-1.764l4.931-2.847a.945.945,0,1,1,.945,1.637L23.9,270.631a.941.941,0,0,1-.472.127",
    transform: "translate(-19.21 -227.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_748",
    "data-name": "Trac\\xE9 748",
    d: "M324.759,271.686a.941.941,0,0,1-.472-.127l-4.931-2.847a.945.945,0,0,1,.945-1.637l4.931,2.847a.945.945,0,0,1-.473,1.764",
    transform: "translate(-272.521 -228.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_749",
    "data-name": "Trac\\xE9 749",
    d: "M343.614,220.433a.945.945,0,0,1-.165-.015l-5.607-.989a.945.945,0,1,1,.328-1.861l5.607.989a.945.945,0,0,1-.163,1.876",
    transform: "translate(-288.055 -185.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_750",
    "data-name": "Trac\\xE9 750",
    d: "M338.19,161a.945.945,0,0,1-.163-1.876l5.607-.989a.945.945,0,0,1,.328,1.861l-5.607.989a.942.942,0,0,1-.165.015",
    transform: "translate(-288.214 -135.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_751",
    "data-name": "Trac\\xE9 751",
    d: "M320.366,100.556a.945.945,0,0,1-.473-1.764l4.931-2.847a.945.945,0,1,1,.945,1.637l-4.931,2.847a.94.94,0,0,1-.472.127",
    transform: "translate(-272.979 -81.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_752",
    "data-name": "Trac\\xE9 752",
    d: "M286.677,51.215a.945.945,0,0,1-.723-1.552l3.66-4.361a.945.945,0,1,1,1.448,1.215l-3.66,4.361a.943.943,0,0,1-.724.338",
    transform: "translate(-244.189 -38.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_753",
    "data-name": "Trac\\xE9 753",
    d: "M241.188,18.924a.946.946,0,0,1-.888-1.269l1.947-5.35a.945.945,0,1,1,1.776.646l-1.947,5.35a.945.945,0,0,1-.888.622",
    transform: "translate(-205.314 -9.984)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.4fa8fb2feedeb876abaa2b6fd7b2c210.svg";
export { ForwardRef as ReactComponent };